<style lang="less" rel="stylesheet/less" scope>
  .pager-box {
    text-align: center;
  }
</style>
<template>
  <div class="pager-box">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pager.pageNo"
      :page-sizes="pageSizes"
      :page-size="pager.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count">
    </el-pagination>
  </div>
</template>
<script type='text/ecmascript-6'>
  export default {
    name: 'LyPaginationBoard',
    props: {
      count: {
        type: Number,
        default: 0
      },
      pageNo:  {
        type: Number,
        required: true
      },
      pageSizes: {
        type: Array,
        default: function () { return [10, 20, 50]}
      }
    },
    data: () => ({
      pager: {
        pageNo: 1,
        pageSize: 10
      }
    }),
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.pager.pageNo = 1;
      },
      handleCurrentChange(val) {
        this.pager.pageNo = val;
      }
    },
    watch: {
      pager: {
        handler: function(val) {
          this.$emit('sizeChange', val.pageNo, val.pageSize);
        },
        deep: true
      },
      pageNo(val) {
        this.pager.pageNo = val;
      }
    }
  }

</script>




// WEBPACK FOOTER //
// src/components/pagination-board/index.vue